export const checkValueAndCall = (value: string | string[], func: Function) => {
    if (value) {
        func(value);
    } else {
        func([]);
    }
};
